import { array, boolean, date, number, object } from "yup"
import { currentStockPercentageField } from "./distribution-center.model"
import { ID2 } from "./yup.common"

export default object({
  currentStockCount: number().label("Ground Stock Count").required(),
  offerStockCount: number().min(0).label("Display Stock Count"),
  isLive: boolean().required("Please select whether the stock is live or not!"),
  unitRate: number().positive().label("Unit Rate").required(),
  discountedRate: number().label("Discounted Rate").required(),
  orderingConditions: object({
    isPickUp: boolean().label("Pick Up"),
    orderLimit: array().of(number().min(0, "Order limit should be positve")),
    isOnlinePaymentAvailable: boolean().label("Online Payment"),
    isCodAvailable: boolean().label("COD Available"),
    isHomeDelivery: boolean().label("Home Delivery"),
  }),
  groupVisibility: array().label("Group Visibility"),
  sellableItemId: ID2("Sellable Item").required(
    "Please enter a valid sellable item"
  ),
  expiryDate: date().label("Expiry Date").nullable(true),
  distributionCentreId: ID2("Distribution Center").required(
    "Please enter a valid distribution center"
  ),
  currentStockPercentage: currentStockPercentageField,
})
